import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import resolvePath from '../../../misc/resolvePath';
import Link from '../../elements/Link';
import RelativeRedirect from '../../elements/RelativeRedirect/RelativeRedirect';
import ErrorBoundary from '../../validate/ErrorBoundary';
import WaitWhileBusy from '../../WaitWhileBusy';
import enrichmentsConnect from './common/connectEnrichments';
import EnrichmentScreen from './common/EnrichmentScreen';
import { Graph, Legends, People, TextAnswerList } from './common/results';
import './EnrichmentsResults.scss';

function preventOverflow(groups, total_answers, i18n) {
    let _list = groups.sort((a, b) => b.count - a.count);
    let newList = _.slice(_list, 0, 10);
    const other = _.slice(_list, 10);
    const summarized =
        (100 / total_answers) * _.sum(other.map((item) => item.count));
    newList.push({
        percentage_of_total: Number.parseFloat(summarized.toFixed(2)),
        group_label: i18n['label.poll.other'],
        group_key: i18n['label.poll.other'],
    });

    return newList;
}

const Footer = ({ primary_color, previousPage, nextPage, i18n }) => {
    return (
        <div
            className={'content'}
            style={{ display: 'flex', flexDirection: 'row' }}
        >
            {previousPage && (
                <Link href={previousPage} className={'VerticalCenter btn'}>
                    {i18n['button.poll.previous']}
                </Link>
            )}
            <Link
                href={nextPage}
                className={'VerticalCenter btn'}
                style={{
                    color: 'white',
                    background: primary_color,
                }}
            >
                {i18n['button.poll.next']}
            </Link>
        </div>
    );
};

const QuestionInfo = (props) => {
    const { text, description } = props;
    return (
        <React.Fragment>
            <h2>{text}</h2>
            <p>{description}</p>
        </React.Fragment>
    );
};
const SelectResults = ({ results, question, i18n }) => {
    switch (question.type || question.answer_type) {
        case 'options':
        case 'rating':
        case 'numeric':
            if (_.size(results.groups) === 2) {
                return <People {...results} />;
            }
            if (_.size(results.groups) > 11) {
                results.groups = preventOverflow(
                    results.groups,
                    results.total_answers,
                    i18n
                );
            }
            return (
                <React.Fragment>
                    <Graph {...results} /> <Legends {...results} />
                </React.Fragment>
            );
        case 'text':
            return <TextAnswerList {...results} />;
    }
    return null;
};

export const EnrichmentsResults = (props) => {
    const {
            currentQuestion,
            previousPage,
            nextPage,
            returnURL,
            event,
            cat,
            i18n,
            category,
            results,
            currentQuestionPosition,
            maxQuestions,
        } = props,
        footerContext = {
            previousPage,
            nextPage,
            primary_color: event.settings.primary_color,
            i18n,
        };

    if (!currentQuestion?.results) {
        return <Redirect to={returnURL} />;
    }

    return (
        <EnrichmentScreen
            event={event}
            enrichmentCategory={cat}
            enrichmentCategory={category}
            currentPosition={currentQuestionPosition}
            maxPosition={maxQuestions}
            footer={<Footer {...footerContext} />}
            returnURL={returnURL}
        >
            <div className={'content results'}>
                <QuestionInfo {...currentQuestion.question} />
                <SelectResults
                    question={currentQuestion.question}
                    results={currentQuestion.results}
                    i18n={i18n}
                />
            </div>
        </EnrichmentScreen>
    );
};

const StateConnectedScreen = connect((state, props) => {
    let enrichment = enrichmentsConnect(state, props);
    const event = state.events[props.eventId].event,
        questions = enrichment.questions,
        currentPath = app.history.location.pathname;

    const currentQuestion = _(questions).find(
        (question) => question.id == props.questionId
    );

    const visibility = parseInt(props.visibility),
        answerNextQuestion = [1],
        showNextResult = [2, 3];

    let nextPage = resolvePath(currentPath, '../../../..'),
        previousPage,
        nextQuestionIndex,
        listOfQuestions,
        returnURL;

    if (answerNextQuestion.includes(visibility)) {
        returnURL = resolvePath(currentPath, '../..');
        // go to next question to answer on if there is any.
        const nextRequiredQuestion = _(questions)
            .filter((q) => {
                return q.number > currentQuestion.number;
            })
            .minBy((q) => {
                return q.number - currentQuestion.number;
            });
        if (nextRequiredQuestion) {
            nextPage = resolvePath(
                currentPath,
                '../../..',
                nextRequiredQuestion.id.toString()
            );
        } else {
            nextPage = resolvePath(currentPath, '../../../..', 'conclusion');
        }
    } else if (showNextResult.includes(visibility)) {
        returnURL = resolvePath(currentPath, '../../../..', 'results');
        // show next question in question list if vis isn't 0 or 1
        listOfQuestions = _(questions)
            .filter((q) => {
                return showNextResult.includes(q.question.show_results);
            })
            .value();

        nextQuestionIndex = parseInt(
            listOfQuestions.findIndex((q) => q.id == props.questionId)
        );

        if (nextQuestionIndex + 1 < _.size(listOfQuestions)) {
            const nextQuestionId = listOfQuestions[nextQuestionIndex + 1].id;
            nextPage = resolvePath(
                currentPath,
                '../../..',
                nextQuestionId.toString(),
                'results',
                '2'
            );
        }
        if (nextQuestionIndex - 1 >= 0) {
            const previousQuestionId =
                listOfQuestions[nextQuestionIndex - 1].id;
            previousPage = resolvePath(
                currentPath,
                '../../..',
                previousQuestionId.toString(),
                'results',
                '2'
            );
        }
    }

    return {
        event,
        i18n: state.i18n.translations,
        currentQuestion,
        previousPage,
        nextPage,
        returnURL,
        category: _(
            state.events[props.eventId].event.enrichment_categories
        ).find({ category: 2 }),
        currentQuestionPosition: nextQuestionIndex + 1,
        maxQuestions: _.size(listOfQuestions),
    };
})(EnrichmentsResults);

export default (props) => (
    <WaitWhileBusy>
        <ErrorBoundary altComponent={<RelativeRedirect to=".." />}>
            <StateConnectedScreen {...props.match.params} />
        </ErrorBoundary>
    </WaitWhileBusy>
);
